import React from 'react';

function QuestionMarkSolid(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M2 12C2 6.47732 6.47732 2 12 2C17.5227 2 22 6.47732 22 12C22 17.5227 17.5227 22 12 22C6.47732 22 2 17.5227 2 12ZM12.0008 6.37583C13.727 6.37583 15.126 7.77587 15.125 9.50167C15.125 10.8254 14.29 12.0058 13.0416 12.4476C12.823 12.5249 12.668 12.7153 12.6327 12.9395L12.625 13.0375V13.8758C12.625 14.221 12.3452 14.5008 12 14.5008C11.6862 14.5008 11.4264 14.2696 11.3818 13.9682L11.375 13.8758V13.0375C11.375 12.2954 11.811 11.6288 12.4783 11.3279L12.6248 11.2691C13.3739 11.004 13.875 10.2956 13.875 9.50129C13.8756 8.46574 13.0363 7.62583 12.0005 7.62583C10.9649 7.62521 10.125 8.46453 10.125 9.5C10.125 9.84518 9.84518 10.125 9.5 10.125C9.15482 10.125 8.875 9.84518 8.875 9.5C8.875 7.77386 10.275 6.37479 12.0008 6.37583ZM12.1093 15.7563L12 15.75L11.8907 15.7563C11.4245 15.8105 11.0625 16.2068 11.0625 16.6875C11.0625 17.2052 11.4823 17.625 12 17.625C12.5177 17.625 12.9375 17.2052 12.9375 16.6875C12.9375 16.2068 12.5755 15.8105 12.1093 15.7563Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default QuestionMarkSolid;
